import React, { useState } from "react";
import { Lightbox, fileUrl } from "./MessageExtras";

// Presentation card: one thumbnail per slide so the user can see the deck and point at the slide to revise («slide 3 ganti gambarnya»).
export function SlidePreviewStrip({ previews = [] }) {
  const [open, setOpen] = useState(null);
  if (!previews.length) return null;
  return (
    <div className="mt-3" data-testid="slide-preview-strip">
      <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-400">{previews.length} slide · klik untuk memperbesar</p>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {previews.map((p) => (
          <button key={p.n} type="button" onClick={() => setOpen(p)} data-testid={`slide-preview-${p.n}`} title={p.title || `Slide ${p.n}`} className="group shrink-0 text-left">
            <img src={fileUrl(p.path)} alt={p.title || `Slide ${p.n}`} loading="lazy" decoding="async" className="h-[84px] w-[150px] rounded-lg border border-slate-200 object-cover transition-transform duration-150 group-hover:scale-[1.03]" />
            <p className="mt-0.5 w-[150px] truncate text-[11px] text-slate-500"><span className="font-semibold text-slate-700">Slide {p.n}</span>{p.title ? <span data-no-i18n> · {p.title}</span> : null}</p>
          </button>
        ))}
      </div>
      {open && <Lightbox media={{ path: open.path, name: `Slide ${open.n} · ${open.title || ""}` }} onClose={() => setOpen(null)} />}
    </div>
  );
}
